import { useEffect, CSSProperties, useState } from "react";

const getCssProperties = (header: any) => {
    const styles = {} as any;

    if (header?.backgroundColor) {
        styles["--header-background-color"] = header.backgroundColor;
    }

    // Social Links

    if (header?.socialLinkColor) {
        styles["--header-icon-fill-color"] = header.socialLinkColor;
    }

    if (header?.hoverSocialLinkColor) {
        styles["--header-icon-hover-fill-color"] = header.hoverSocialLinkColor;
    }

    // Anchor

    if (header?.anchorColor) {
        styles["--header-anchor-text-color"] = header.anchorColor;
    }

    if (header?.hoverAnchorColor) {
        styles["--header-anchor-hover-text-color"] = header.hoverAnchorColor;
    }

    // Burger

    if (header?.burgerColor) {
        styles["--header-burger-color"] = header.burgerColor;
    }

    // Action Button

    const headerButton = header?.headerButtons?.[0] && header.headerButtons.length > 0 ? header.headerButtons[0] : undefined;

    if (headerButton?.content.backgroundColor) {
        styles["--button-override-background-color"] = headerButton.content.backgroundColor;
    }

    if (headerButton?.content.hoverBackgroundColor) {
        styles["--button-override-hover-background-color"] = headerButton.content.hoverBackgroundColor;
    }

    if (headerButton?.content.textColor) {
        styles["--button-override-text-color"] = headerButton.content.textColor;
    }

    if (headerButton?.content.hoverTextColor) {
        styles["--button-override-hover-text-color"] = headerButton.content.hoverTextColor;
    }

    if (headerButton?.content.borderWidth) {
        styles["--button-override-border-width"] = `${headerButton.content.borderWidth}px`;
    }

    if (headerButton?.content.borderColor) {
        styles["--button-override-border-color"] = headerButton.content.borderColor;
    }

    // Overlay

    if (header?.overlayBackgroundColor) {
        styles["--header-overlay-background-color"] = header.overlayBackgroundColor;
    }

    if (header?.overlayAnchorBackgroundColor) {
        styles["--header-overlay-anchor-background-color"] = header.overlayAnchorBackgroundColor;
    }

    if (header?.overlayAnchorColor) {
        styles["--header-overlay-anchor-color"] = header.overlayAnchorColor;
    }

    if (header?.overlayBorderColor) {
        styles["--header-overlay-border-color"] = header.overlayBorderColor;
    }

    if (header?.overlayCloseColor) {
        styles["--header-overlay-burger-color"] = header.overlayCloseColor;
    }

    if (header?.overlaySocialLinkColor) {
        styles["--header-overlay-icon-fill-color"] = header.overlaySocialLinkColor;
    }

    // Opacity and background color for fixed header (Only used in Header6)
    const hexToRgba = (hex: string, opacity: number = 1): string => {
        if (!hex) return `rgba(255, 255, 255, ${opacity})`;

        const cleaned = hex.replace("#", "");
        const normalized =
            cleaned.length === 3
                ? cleaned
                      .split("")
                      .map((c) => c + c)
                      .join("")
                : cleaned;

        const bigint = parseInt(normalized, 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;

        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    };

    const opacity = header?.fixedBackgroundOpacity ?? 1;
    const rgbaColor = hexToRgba(header?.backgroundColor, opacity);

    styles["--header-background-rgba"] = rgbaColor;

    return styles;
};

export default (header?: any): any => {
    const [result, setResult] = useState<CSSProperties>(getCssProperties(header));

    useEffect(() => {
        setResult(getCssProperties(header));
    }, [header]);

    return result;
};
